import React from "react";
import "./UserChip.css";

interface Props {
  id?: number | string;
  userName: string;
  onClick?: () => void;
}

const UserChip: React.FC<Props> = ({ id, userName, onClick }) => {
  return (
    <div className="group-chip" key={id}>
      <span className="group-chip-avatar">
        {(() => {
          const parts = userName?.trim().split(" ").filter(Boolean) || [];

          if (parts.length === 1) {
            return parts[0][0].toUpperCase();
          }

          const firstInitial = parts[0][0];
          const lastInitial = parts[parts.length - 1][0];

          return (firstInitial + lastInitial).toUpperCase();
        })()}
      </span>
      {userName}
      {onClick && (
        <button type="button" className="group-chip-close" onClick={onClick}>
          ×
        </button>
      )}
    </div>
  );
};

export default UserChip;
